<template>
  <div class="page-wrapper">
    <SearchNav />
    <div class="page-content">
      <div class="pay-pages">
        <div class="page-nav">
          <!-- <img class="logo" :src="require('@/assets/img/logo.png')" alt="" /> -->
          <h1 class="logo-text">收银台</h1>
        </div>
        <div class="page-body">
          <div class="page-body-top">
            <div class="pay-info-wrapper">
              <img
                v-if="timeOut && auditStatus !== 1"
                class="success-img"
                :src="require('@/assets/img/warning.png')"
                alt=""
                srcset=""
              />
              <img v-else class="success-img" :src="require('@/assets/img/success-icon.png')" alt="" srcset="" />
              <p v-if="timeOut && auditStatus !== 1" class="success-text">订单已超时！</p>
              <p v-else class="success-text">订单提交成功！</p>
              <h1 v-if="totalAmount" class="pay-num orange">¥{{ price(totalAmount) }}</h1>
              <h1 v-else class="pay-num orange">¥{{ price(orderInfo.orderAmount) }}</h1>
              <p class="pay-text">应付金额</p>
              <p v-if="orderInfo.payId === 0" class="pay-countdown">
                下单后请在{{ hours() }}内于
                <span class="black">APP</span>
                中完成支付，倒计时：
                <span class="orange">{{ payTimeOut }}</span>
              </p>
              <p v-else class="pay-countdown">
                下单后请在{{ hours() }}内支付完成，倒计时：
                <span class="orange">{{ payTimeOut }}</span>
              </p>
              <p v-if="orderInfo.userAddress" class="pay-person-info">
                收货地址：{{ orderInfo.userAddress.province }} {{ orderInfo.userAddress.city }}
                {{ orderInfo.userAddress.region }} {{ orderInfo.userAddress.address }}
                {{ orderInfo.userAddress.name }}
                {{ orderInfo.userAddress.mobile }}
              </p>
              <div v-if="isLot" @click="goList" class="go-detail pointer">查看订单列表 ></div>
              <div v-else @click="goDetail" class="go-detail pointer">查看订单详情 ></div>
            </div>
          </div>
          <div v-if="!timeOut && orderInfo.payId !== 0" class="page-body-bot">
            <PayBank :payId="orderInfo.payId" :accountInfo="accountInfo" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/components/SearchNav';
import PayBank from './components/PayBank';
import * as api from '@/services';
import dayjs from 'dayjs';
import { priceFenToYuan, parseCountDown } from '@/helpers/utils';
export default {
  name: 'orderPay',
  computed: {
    payTimeOut() {
      const diffTime = dayjs(this.orderInfo.payTimeout) - dayjs();
      return `${parseCountDown(diffTime.valueOf())}`;
    },
    isLot() {
      return this.$route.query.isLot;
    },
    totalAmount() {
      return this.$route.query.totalAmount;
    }
  },
  components: {
    PayBank,
    SearchNav
  },
  mounted() {
    this.$store.dispatch('layout/SET_FOOTER', false);
    this.getOrderInfo();
  },

  data() {
    return {
      timeOut: false, // 支付时间是否超时
      auditStatus: null,
      orderInfo: {},
      accountInfo: {}
    };
  },
  beforeDestroy() {
    this.$store.dispatch('layout/SET_FOOTER', true);
  },
  methods: {
    price(val) {
      return priceFenToYuan(val);
    },
    hours() {
      let hours = dayjs(this.orderInfo.payTimeout).diff(dayjs(this.orderInfo.submitOrderTime), 'hours');
      let minutes = dayjs(this.orderInfo.payTimeout).diff(dayjs(this.orderInfo.submitOrderTime), 'minutes');
      if (hours === 0) {
        return minutes + '分钟';
      } else {
        return hours + '小时';
      }
    },
    goDetail() {
      this.$router.push(`/orderDetail?orderSn=${this.$route.params.orderSn}`);
    },
    goList() {
      this.$router.push(`/orderList`);
    },
    async getOrderInfo() {
      const res = await api.order.getOrderDetail({ orderSn: this.$route.params.orderSn });
      this.auditStatus = res.auditStatus;
      this.orderInfo = res;
      this.timeOut = dayjs(this.orderInfo.payTimeout) - dayjs() <= 0;
      if (this.orderInfo.payId === 2) {
        this.getPayAccount();
      }
    },
    async getPayAccount() {
      const res = await api.order.queryPayAccount({ orderSn: this.$route.params.orderSn });
      this.accountInfo = res;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  /deep/ .banner__warp {
    width: 1232px;
    margin: 0 auto;
    background-color: #ffffff;
  }
  height: inherit;
  .page-content {
    background-color: #f6f6f6;
    padding-bottom: 50px;
  }
  .pay-pages {
    width: 1232px;
    margin: 0 auto;
    min-height: calc(100vh - 238px);
  }
  .page-nav {
    padding-top: 16px;

    display: flex;
    align-items: center;
    margin: 16px 0;
    .logo {
      width: 81px;
      height: 24px;
      margin-right: 8px;
    }
    .logo-text {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
  .page-body {
    margin: 0 auto;
    background: #ffffff;
    border-radius: 8px;
    padding-bottom: 40px;

    .page-body-top {
      .pay-info-wrapper {
        text-align: center;
        .success-img {
          width: 48px;
          height: 48px;
          margin-top: 56px;
        }
        .success-text {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
        }
        .pay-num {
          font-size: 34px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }
        .orange {
          color: #d96900;
        }
        .pay-text {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
        }
        .pay-countdown {
          font-size: 12px;
          font-weight: 400;
          color: #767676;
          margin-top: 6px;
          .black {
            color: #333333;
          }
        }
        .pay-person-info {
          font-size: 12px;
          font-weight: 400;
          color: #767676;
          margin-top: 8px;
        }
        .go-detail {
          margin-top: 12px;
          height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1e8dff;
          line-height: 18px;
        }
      }
    }
    .page-body-bot {
      margin: 0 40px;
      margin-top: 40px;
      background: #ffffff;
      border: 1px dashed #e2e2e2;
      padding-bottom: 103px;
    }
  }
}
</style>
